// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WqhcpL{position:relative;display:inline-block;cursor:pointer;width:168px}.WqhcpL .yDliY8{box-sizing:border-box}.xelP18{position:absolute;top:15px;pointer-events:none;height:6px;width:10px;display:flex}.xelP18.u72o0R{right:12px}.xelP18.eKP8F7{left:12px}.xelP18 svg{min-width:100%}.yDliY8{width:100%;color:#ebebeb;font-size:14px;height:34px;border:0;-moz-appearance:none;-webkit-appearance:none;border-radius:2px;background-color:rgba(77,77,77,0.8);padding:0 30px 0 15px;outline:none;transition:background-color 0.3s ease}.yDliY8 option{color:#000000}.yDliY8:focus{outline:none;box-shadow:0 0 3px 0 rgba(0,0,0,0.1)}.yDliY8:hover{background-color:rgba(77,77,77,0.9)}.yDliY8:-moz-focusring{color:transparent;text-shadow:0 0 0 white}.yDliY8::-ms-expand{display:none}.yDliY8:focus::-ms-value{background:none}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `WqhcpL`,
	"select": `yDliY8`,
	"arrow-down": `xelP18`,
	"arrowDown": `xelP18`,
	"ltr": `u72o0R`,
	"rtl": `eKP8F7`
};
export default ___CSS_LOADER_EXPORT___;
